import { useContext } from "react";
import MainSelect from "components/MainSelect/MainSelect.view";
import { useStyles } from "./RCACorporateDashboardFilters.styles";
import { RCAAPComplianceRangeEnum } from "../../../../RCAAPCompliance/RCAAPComplianceInterfaces";
import useRCAAPComplianceFilters from "../../../../RCAAPCompliance/components/filters/RCAAPComplianceFilters/useRCAAPComplianceFilters";
import { Box, InputLabel, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import RCADivisionsDropdown from "pages/Corporate/RCA/components/RCADivisionsDropdown/RCADivisionsDropdown";
import RCARegionsDropdown from "pages/Corporate/RCA/components/RCARegionsDropdown/RCARegionsDropdown";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { RCACorporateDashboardContext } from "contexts/RCACorporateDashboardContext/RCACorporateDashboardContext";
import DefaultFiltersButton from "pages/Corporate/RCA/components/DefaultFiltersButton/DefaultFiltersButton";

const rcaComplianceRangeValues = Object.values(RCAAPComplianceRangeEnum);

const RCACorporateDashboardFilters = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const mainClasses = useRCAMainStyles();
    const {
        filters,
        handleSetFilters,
        handleSetDivisions,
        handleSetRegions,
        loadingDefaultOperations,
        isFiltersDefault,
        handleRemoveDefaultFilters,
        handleSetFiltersDefault,
        userFiltersDefault,
    } = useContext(RCACorporateDashboardContext);
    const { rcaComplianceOptions } = useRCAAPComplianceFilters({ rcaComplianceRangeOptions: rcaComplianceRangeValues });

    return (
        <div className={classes.select}>
            <Box>
                <InputLabel>
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabel}>
                        {t("corporate_dashboard.filters.division")}
                    </Typography>
                </InputLabel>
                <RCADivisionsDropdown
                    multiple
                    loadingDefaults={loadingDefaultOperations}
                    value={filters.divisionIds}
                    handleOnComponentMount={(divisionIds, isFirstFire) => {
                        handleSetDivisions(divisionIds as number[], divisionIds.length, isFirstFire);
                    }}
                    onChange={(values) => {
                        handleSetDivisions(values as number[]);
                    }}
                />
            </Box>
            <Box>
                <InputLabel>
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabel}>
                        {t("corporate_dashboard.filters.region")}
                    </Typography>
                </InputLabel>
                <RCARegionsDropdown
                    multiple
                    loadingDefaults={loadingDefaultOperations}
                    divisionIds={filters.divisionIds}
                    value={filters.regionIds}
                    handleOnComponentMount={(regionIds, isFirstFire) => {
                        handleSetRegions(regionIds as number[], regionIds.length, isFirstFire);
                    }}
                    onChange={(values) => {
                        handleSetRegions(values as number[]);
                    }}
                />
            </Box>
            <MainSelect
                fullWidth={false}
                multiple={false}
                value={filters.periodOption}
                options={rcaComplianceOptions || []}
                onChange={(e) => handleSetFilters(e.target.value as number)}
            />
            <DefaultFiltersButton
                isDefault={isFiltersDefault}
                loading={loadingDefaultOperations}
                hasUserDefault={!!userFiltersDefault}
                onRemoveDefault={handleRemoveDefaultFilters}
                onSaveOrUpdate={() => handleSetFiltersDefault(filters)}
                variant="contained"
                color="info"
                className={mainClasses.contentButton}
            />
        </div>
    );
};

export default RCACorporateDashboardFilters;
